import React, { useState, useEffect } from 'react'
import Maybe from 'components/__new/common/Maybe';
import { ReactComponent as IconSearch } from "assets/images/icons/icon-search.svg";
import { ReactComponent as IconAdd } from "assets/images/icons/project-icons/plus-light.svg"
import { ReactComponent as IconCheckCircle } from "assets/images/icons/project-icons/check-circle-green-bg.svg"
import { ReactComponent as IconRemove } from "assets/images/icons/project-icons/times-light.svg"
import { useDispatch, useSelector } from 'react-redux';
import * as walletAction from "store/entities/wallet/action";
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomCheckbox from 'components/__new/common/CustomCheckbox';
import { getTransferBeneficiaries } from 'store/entities/transfers/action';
import useEmptyData from 'hooks/useEmptyData';
import { SelectInput } from 'components/__new/common/form';


const EarnipayMultipeTransfer = ({
    toggleEarnipayTransferType,
    toggleTransferDestination,
    isWideViewOpen,
    setIsWideViewOpen,
    earnipayPreviewItems,
    setEarnipayPreviewItems,
    selectedSourceAccount, 
    setSelectedSourceAccount
}) => {
    
    const dispatch = useDispatch();
    const {validateEarnipayAccountLoading, validateEarnipayAccountData, multipleSourceWalletId, businessAccounts, businessAccountsLoading} = useSelector((state) => state.entities.wallet);
    const { getTransferBeneficiariesLoading, getTransferBeneficiariesData } = useSelector((state) => state.entities.transfers);

    const expenseAccounts = businessAccounts?.status === "success" && businessAccounts?.data?.filter(account => account?.walletType.toLowerCase() === 'expense') || [];

    const [form, setForm] = useState({
        accountNumber: "",
        walletId: multipleSourceWalletId ?? "",
        amount: "",
    });

    const [beneficiariesShown, setBeneficiariesShown] = useState(false);
    const [validatedBeneficiary, setValidatedBeneficiary] = useState(null);
    
    const addBatchBeneficiaries = (batch) => {
        const duplicateAccountNumber = earnipayPreviewItems.some(obj1 => {
            return batch.some(obj2 => obj1.accountNumber === obj2.accountNumber);
        });
        
        if(duplicateAccountNumber === true) {
            toast.error("Duplicate beneficiaries can't be added")
        } else {
            setEarnipayPreviewItems([...earnipayPreviewItems, ...batch])
            setBeneficiariesShown(false);
            setIsWideViewOpen(true);
        }
    
    }
    
    const onClose = () => {
        toggleEarnipayTransferType();
        toggleTransferDestination();
    }
    
    const resetValues = () => {
        setForm({accountNumber: "", walletId: multipleSourceWalletId ?? form?.walletId});
        setValidatedBeneficiary(null);
    }
    
    const onSubmit = (e) => e.preventDefault();
    
    const addAnotherBeneficiary = () => {
        if(earnipayPreviewItems?.length === 20) {
            toast.error(`You can only add ${earnipayPreviewItems?.length} recipients`)
        } else {
            if(validateEarnipayAccountData === null) {
                toast.error("Only validated accounts can be added. Please re-validate the account number")
            } else {
                const duplicateItem = earnipayPreviewItems?.find((item) => item?.accountNumber === validatedBeneficiary?.accountNumber)
                
                if(duplicateItem !== undefined) {
                    toast.error(`${duplicateItem?.accountName} has already been added`)
                } else {
                    setEarnipayPreviewItems([
                        ...earnipayPreviewItems,
                        {...validatedBeneficiary, amount: 0, fee: 0}
                    ])
                    setIsWideViewOpen(true);
                    resetValues();
                }

                // dispatch source wallet to state
                dispatch(walletAction.multipleSourceWalletId(form?.walletId))
            }
        }
    }
    
    
    useEffect(() => {
        if(form?.accountNumber?.length === 10) {
            dispatch(walletAction.validateEarnipayAccount(form?.accountNumber));
        }
        // eslint-disable-next-line
    }, [form.accountNumber])
    
    
    useEffect(() => {
        if(validateEarnipayAccountData?.success === true && form?.accountNumber?.length === 10) {
            setValidatedBeneficiary(validateEarnipayAccountData?.data)
        } else {
            setValidatedBeneficiary(null)
        }
        // eslint-disable-next-line
    }, [validateEarnipayAccountData])
    
    
    useEffect(() => {
        resetValues();
        setEarnipayPreviewItems([]);
        dispatch(getTransferBeneficiaries({type: "intra"}))
        // eslint-disable-next-line
    }, [])
    
    return (
        <div className='w-full relative'>
            <form onSubmit={onSubmit}>
                <SelectInput
                    disabled={multipleSourceWalletId !== null}
                    label="Source Account"
                    value={form?.walletId || ""}
                    onChange={(e) => {
                        const { value } = e.target;
                        const selectedSource = expenseAccounts?.find(account => account?.walletId === +value);
                        selectedSource && setSelectedSourceAccount(selectedSource);
                        setForm({...form, walletId: value});
                    }}
                >
                    <option value="">{businessAccountsLoading ? "Fetching source accounts..." : "Select Source Account"}</option>
                    {expenseAccounts?.map((account) => (
                        <option key={account?._id} value={account?.walletId}>{account?.accountName}</option>
                    ))}
                </SelectInput>
                <div className="form-group relative pt-2">
                    <div className="w-full flex items-center justify-between">
                        <label>Earnipay Account</label>
                        <div onClick={() => setBeneficiariesShown(!beneficiariesShown)} className='text-sm cursor-pointer border-b border-ep-primary-600 text-ep-primary-600 pb-[0.5px]'>
                            {beneficiariesShown ? "Close search" : "Or Search Beneficiary List"}
                        </div>
                    </div>
                    
                    <input
                        type="text"
                        min={0}
                        disabled={validateEarnipayAccountLoading}
                        id="prl-input"
                        className="form-input"
                        value={form.accountNumber}
                        placeholder="Account Number"
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value) && value.length <= 10) {
                                setForm({...form, accountNumber: e.target.value});
                                setValidatedBeneficiary(null);
                            }
                        }}
                    />
                    
                    <Maybe condition={validatedBeneficiary !== null}>
                        <div className="w-full flex items-center justify-start">
                            <div className="flex items-center text-sm">
                                <IconCheckCircle width={15} />
                                <div className='ml-1.5 text-[#153344] capitalize'>
                                    {validatedBeneficiary?.accountName}
                                </div>
                            </div>
                        </div>
                    </Maybe>
                </div>
                
                <div className="mt-10 border-t">
                    <button disabled={validateEarnipayAccountLoading} type="button" onClick={addAnotherBeneficiary} className="btn btn-transparent-primary w-full disabled:cursor-not-allowed">
                        <IconAdd width={15} />&nbsp;
                        {validateEarnipayAccountLoading ? "Validating..." : "Add Another"}
                    </button>
                </div>
                
                <Maybe condition={isWideViewOpen === false}>
                    <div className="w-full flex items-center justify-end pt-8">
                        <button type="button" onClick={onClose} className="btn btn-transparent-primary mr-3">
                            Cancel
                        </button>
                        
                        <button disabled type="button" className="btn btn-ep-primary">
                            Continue
                        </button>
                    </div>
                </Maybe>
            </form>
        
            <Maybe condition={beneficiariesShown}>
                <BeneficiariesList
                    isWideViewOpen={isWideViewOpen}
                    addBatchBeneficiaries={addBatchBeneficiaries}
                    loading={getTransferBeneficiariesLoading}
                    beneficiaries={getTransferBeneficiariesData?.data?.docs}
                />
            </Maybe>
        </div>
    )
}

const BeneficiariesList = ({beneficiaries, loading, addBatchBeneficiaries, isWideViewOpen}) => {
    
    const [selected, setSelected] = useState([]);
    const [allBeneficiaries, setAllBeneficiaries] = useState([]);
    const [batch, setBatch] = useState([]);
    const [keyword, setKeyword] = useState("");
    const { ListBeneficiariesEmptyData, SearchBeneficiariesEmptyData } = useEmptyData();
    
    const filteredBeneficiaries = allBeneficiaries?.filter((beneficiary) => {
        if(keyword === "") {
            return true
        } else {
            return beneficiary?.details?.accountName?.toLowerCase()?.includes(keyword?.toLowerCase()) ||
                beneficiary?.details?.bankName?.toLowerCase()?.includes(keyword?.toLowerCase())
        }
    })
    
    const toggleSelection = (beneficiary) => {
        const itemInArray = batch?.indexOf(beneficiary?._id) > -1;
        if(itemInArray) {
            setBatch([...batch?.filter((item) => item !== beneficiary?._id)])
            setSelected([...selected?.filter((item) => item?._id !== beneficiary?._id)])
        } else {
            setBatch([...batch, beneficiary?._id])
            setSelected([...selected, {...beneficiary}])
        }
    }
    
    const addSelected = () => {
        const payload = selected?.map(({accountName,accountNumber}) => ({
            accountName,
            accountNumber,
        }))
        
        addBatchBeneficiaries(payload)
    }
    
    useEffect(() => {
        if(beneficiaries?.length > 0) {
            setAllBeneficiaries(beneficiaries)
        }
    }, [beneficiaries])
    
    
    return (
        <div style={{ position: "absolute", right: isWideViewOpen ? "-310px" : "-340px", height: "300px", top: "-140px", zIndex: 50 }} className="overflow-y-scroll shadow-xl text-sm modal-list-wrap bg-white w-[300px] rounded-lg">
            <Maybe condition={loading === true}>
                <div className="py-5 text-center mt-8">
                    <div className="font-medium">
                        Fetching beneficiaries
                    </div>
                    <div className="mt-4 flex justify-center">
                        <FontAwesomeIcon icon="circle-notch" spin className="text-2xl" />
                    </div>
                </div>
            </Maybe>
            
            <ListBeneficiariesEmptyData condition={loading === false && beneficiaries?.length === 0} />
            
            <Maybe condition={loading === false && beneficiaries?.length > 0}>
                <div className="w-full bg-white sticky top-0 left-0 p-4">
                    <div className="w-full relative">
                        <input
                            type="text"
                            value={keyword}
                            placeholder='Search Beneficiaries' 
                            onChange={(e) => setKeyword(e.target.value)}
                            className='bg-[#f3f4f6] w-full relative text-xs pl-9 !border-0 !ring-0 rounded-lg form-input'
                        />
                        
                        <IconSearch className='absolute left-2 top-2.5' width={18} />
                    </div>
                </div>
                
                <SearchBeneficiariesEmptyData condition={keyword?.length > 0 && filteredBeneficiaries?.length === 0} />
                
                <div className="w-full p-4 pt-1">
                    
                    <Maybe condition={selected?.length > 0}>
                        <div className="py-4 w-full flex items-center justify-start flex-wrap">
                            {selected?.map((item) => {
                                const getAccountName = (name) => {
                                    if(name?.length > 12) {
                                        return `${name?.substring(0, 12)}...`
                                    }
                                    return name
                                }
                                return (
                                    <div key={item?._id} className="mb-2 bg-[#f3f4f6] rounded-md py-1 px-1.5 text-sm capitalize flex items-center justify-start w-[47%] mr-2 whitespace-nowrap">
                                        {getAccountName(item?.accountName?.toLowerCase())}
                                        <IconRemove onClick={() => toggleSelection(item)} cursor="pointer" className='ml-2' />
                                    </div>
                                )
                            })}
                        </div>
                    </Maybe>
                    
                    
                    <div>
                        {filteredBeneficiaries?.map((beneficiary, index) => ( 
                            <div key={index} className="mb-2.5 pb-2 border-b flex items-center">
                                
                                <CustomCheckbox
                                    widthHeight={4} 
                                    checked={batch?.includes(beneficiary?._id)}
                                    onClick={() => toggleSelection(beneficiary)}
                                />
                                
                                <div className="w-3/4 pl-2">
                                    <div className="font-medium capitalize text-[#374151]">{beneficiary?.accountName?.toLowerCase()}</div>
                                    <div className="flex items-center pt-1 text-gray-500">
                                        <div>{beneficiary?.accountNumber}</div>
                                        <span className='h-1 w-1 rounded-full bg-gray-500 mx-1' />
                                        <div>Earnipay</div>
                                    </div>
                                </div>
                            </div>
                            )
                        )}
                    </div>
                </div>
                
                <div className="w-full bg-white sticky !bottom-0 left-0 p-4">
                    <button disabled={!selected?.length} onClick={addSelected} className="btn border border-[#d0d5dd] w-full disabled:cursor-not-allowed">
                        Add
                    </button>
                </div>
            </Maybe>
            
            <div className='sticky bottom-0 h-2 bg-white w-full left-0' />
        </div>
    )
}

export default EarnipayMultipeTransfer